import HomeHeaderOther from "@/components/HomeHeader/indexOther";
import InviteProgress from "@/components/InviteProgress";
import { LocalConfig, NumericalConfig, PaymentConfig } from "@/config";
import { LocationInfo } from "@/data/LocationInfo";
import { PersistContext } from "@/data/PersistProvider";
import { useEnhancedHistory } from "@/data/RouterProvider";
import { SendCMD } from "@/utils/HTTPRequest";
import { ChannelRemind } from "@/utils/UrlHelper";
import React, { useContext, useState, useEffect } from "react";
import { Form, Picker, Popup, Toast, Popover  } from "react-vant";
import style from "./style.less";

const games = {
  208: {
    id: 208,
    url: process.env.PREACT_APP_ENV_CONFIG.game3Url + "?game_id=208",
  },
};
const Withdraw = () => {
  const { getPersist, reloadUserInfo } = useContext(PersistContext);
  const inputRef = React.useRef(null);
  const gasPopoverRef = React.useRef(null);
  const userInfo = getPersist("user_info");
  const history = useEnhancedHistory();
  const phone = getPersist("last_phone");
  const [formWithdraw] = Form.useForm();
  const onFinishWithdraw = (values) => {
    console.log(values);
  };

  //输入框
  const [stateWithdraw, setStateWithdraw] = useState(0);
  const [suficientData, setSuficientData] = useState(null);

  const [money, setMoney] = useState(0);
  const [gas, setGas] = useState(0);
  const [showChooseChannel, setShowChooseChannel] = useState(false);
  const [paymentIndex, setPaymentIndex] = useState(0);
  const [payments, setPayments] = useState(
    PaymentConfig.payments.map((item, index) => {
      return {
        value: index,
        text: item.text,
        type: item.type,
      };
    })
  );

  let withdrawableAmount = money ? money : 0;
  let minWithdraw = NumericalConfig.minWithdrawAmount / 100;
  let maxWithdraw = NumericalConfig.maxWithdrawAmount / 100;
  if (getPersist("abtest_tag") == "t8:g2") {
    withdrawableAmount = Math.min(money ? money : 0, gas ? gas / NumericalConfig.gasBurnRatio : 0);
  }

  useEffect(() => {
    let bgSettings = getPersist("bgSettings");
    let merchant_usage = 0;
    if (bgSettings && bgSettings.settings && bgSettings.settings.merchant_usage) {
      merchant_usage = bgSettings.settings.merchant_usage;
    }
    console.log("bgSettings", bgSettings);
    console.log("merchant_usage", merchant_usage);
    let tmpPayments = [];
    PaymentConfig.payments
      .filter((item) => item.merchantId == merchant_usage)
      .map((item, index) => {
      tmpPayments.push({
          value: index,
          text: item.text,
          type: item.type,
        });
      });
    console.log("tmpPayments", tmpPayments);
    setPayments(tmpPayments);
  }, [getPersist("bgSettings")]);
  const onWithdrawInputChange = (e) => {
    let value = e.target.value;
    console.log(value);
    if (value) {
      if (typeof value == "string") {
        value = parseInt(value, 10);
      }
      if (value > maxWithdraw) {
        value = maxWithdraw;
      }
      if (value < 1) {
        value = 1;
      }
      inputRef.current.value = value;
      setStateWithdraw(value);
    }
  };

  const onGoPlayClick = () => {
    history.push(ChannelRemind(`/game?game_id=${games[208].id}&url=${encodeURI(games[208].url)}`));
  };

  const onGoDepositClick = () => {
    history.push(ChannelRemind("/deposit"));
  };
  React.useEffect(() => {
    if (!getPersist("dataLoaded")) {
      return;
    }
    if (!getPersist("user_info")) {
      history.replace(ChannelRemind(`/login?${getPersist("last_phone") ? "" : "reg=1&"}back_to=-1`));
      return;
    }
    setMoney(getPersist("user_info").money.coin / 100);
    setGas(getPersist("user_info").money.gas ? getPersist("user_info").money.gas / 100 : 0);
    SendCMD("withdraw_sufficient", {
      token: getPersist("user_info").token,
    }).then((res) => {
      setSuficientData(res.data);
    });
    reloadUserInfo();
  }, [getPersist("dataLoaded"), getPersist("user_info")]);

  const doWithdraw = async () => {
    if (stateWithdraw < minWithdraw) {
      Toast.info({ message: `The amount cannot be less than ${minWithdraw}`, duration: 2000 });
      return;
    }
    if (stateWithdraw > maxWithdraw) {
      Toast.info({ message: `The amount cannot be more than ${maxWithdraw}`, duration: 2000 });
      return;
    }
    if (stateWithdraw > money) {
      Toast.info({ message: `Insufficient balance for this withdraw`, duration: 2000 });
      return;
    }
    if (getPersist("abtest_tag") == "t8:g2" && stateWithdraw > gas / NumericalConfig.gasBurnRatio) {
      Toast.info({ message: `Insufficient gas for this withdraw`, duration: 2000 });
      return;
    }

    if (!suficientData || !suficientData.sufficient) {
      let res = await SendCMD("withdraw_sufficient", {
        token: getPersist("user_info").token,
      });
      if (!res.status) {
        Toast.fail({
          message: "Error, Please try again later",
          duration: 2000,
        });
        console.log(res.errdesc);
        return;
      } else if (!res.data.sufficient) {
        setSuficientData(res.data);
        return;
      }
      setSuficientData(res.data);
    }

    if (stateWithdraw > 0) {
      SendCMD("withdraw", {
        token: getPersist("user_info").token,
        price: Number(stateWithdraw) * 100,
        merchant_id: process.env.PREACT_APP_ENV_CONFIG.merchantId,
        type: payments[paymentIndex].type,
      }).then((res) => {
        if (!res.status) {
          Toast.fail({
            message: "Error",
            duration: 2000,
          });
          console.log(res.errdesc);
        } else if (res.data.need_audit) {
          history.push(ChannelRemind("/withdrawControl"));
        } else {
          Toast.success({
            message: "Success",
            duration: 2000,
            onClose: function () {
              setStateWithdraw("");
              location.reload();
            },
          });
        }
      });
    }
  };
  let amountPlaceholder = `${(NumericalConfig.minWithdrawAmount / 100).toFixed(0)} - ${(
    NumericalConfig.maxWithdrawAmount / 100
  ).toFixed(0)}`;
  // if (getPersist("abtest_tag") == "t8:g2") {
  //   if (!gas || gas * NumericalConfig.gasBurnRatio < NumericalConfig.minWithdrawAmount) {
  //     amountPlaceholder = `not enough gas`;
  //   }
  // }
  return (
    <div class={style.page_container}>
      <HomeHeaderOther title={"Withdraw"} />
      <div class={style.withdraw_content}>
        {getPersist("abtest_tag") == "t8:g2" && (
          <div class={style.withdraw_sub_balance_group}>
            <div class={style.withdraw_sub_balance}>
              <span>Gas remaining</span>
              <span class={style.last}>
                {(gas ? gas : 0).toLocaleString("en-US")}
                {` (for ${(gas ? gas / NumericalConfig.gasBurnRatio : 0).toLocaleString("en-US", {
                  maximumFractionDigits: 2,
                })} ${LocalConfig.currencyCode} max)`}
              </span>
            </div>
            <div class={style.withdraw_sub_balance}>
              <span>Total balance</span>
              <span class={style.last}>
                {(money ? money : 0).toLocaleString("en-US", { maximumFractionDigits: 2 })} {LocalConfig.currencyCode}
              </span>
            </div>
          </div>
        )}
        <div class={style.withdraw_balance}>
          <span>Balance Withdrawable</span>
          <span class={style.last}>{withdrawableAmount.toLocaleString("en-US", { maximumFractionDigits: 2 })} {LocalConfig.currencyCode}</span>
        </div>
        {getPersist("abtest_tag") == "t8:g2" && (
          <div
            class={style.withdraw_sub_balance_group}
            style={{ display: "flex", flexDirection: "row", justifyContent: "flex-end", marginTop: 0 }}
          >
            {money > gas / NumericalConfig.gasBurnRatio && (
              <div class={style.withdraw_sub_desc}>
                <Popover
                  ref={gasPopoverRef}
                  theme="dark"
                  placement="bottom-end"
                  reference={
                    <span class={style.withdraw_get_gas_pop_trigger}>
                      How to withdraw all {(money ? money : 0).toLocaleString("en-US", { maximumFractionDigits: 2 })} {LocalConfig.currencyCode}?
                    </span>
                  }
                >
                  <div class={style.get_gas_desc}>
                    1 KES withdrawal requires {NumericalConfig.gasBurnRatio} gas. <br />
                    <br />
                    Get gas by <br /> <span onClick={() => onGoPlayClick()}>Playing game</span> (more bets more gas)
                    {/* Get gas by <br /> <span onClick={() => onGoPlayClick()}>Playing game</span> (1KES bet for 1gas)
                    <br /> or by <br />
                    <span onClick={() => onGoDepositClick()}>Depositing </span> (1KES deposit for 1gas). */}
                  </div>
                </Popover>
              </div>
            )}
          </div>
        )}
        <div class={style.deposit_inbox} onClick={() => setShowChooseChannel(true)}>
          <div class={style.withdraw_pol}>Channel</div>
          <div class={style.withdraw_changemoney}>{payments[paymentIndex] && payments[paymentIndex].text}</div>
          <img class={style.withdraw_jiantou} src={require("@/assets/images/home/jiantou2.png").default} />
          <p />
        </div>
        <div class={style.withdraw_channelbox}>
          <img src={require("@/assets/images/home/icon_tanhao.png").default} alt="" />
          <div>
            <div class={`${style.depositeText} ${style.greenColor}`} style={{ fontWeight: 700 }}>
              This channel is currently available. Please feel free to withdraw.
            </div>
          </div>
        </div>
        <div class={style.deposit_inbox}>
          <input
            type="text"
            ref={inputRef}
            id={style.withdraw_amount}
            class={style.withdraw_changemoney}
            value={stateWithdraw ? stateWithdraw : ""}
            placeholder={amountPlaceholder}
            onChange={(value) => {
              onWithdrawInputChange(value);
            }}
          />
          <div class={style.withdraw_pol}>Amount</div>
          <div class={style.deposit_fork} onClick={() => setStateWithdraw(null)}>
            ×
          </div>
          <p class={style.withdraw_bt}>
            <span>Actual amount</span>
            <span class={style.withdraw_btr}>
              {stateWithdraw ? Math.floor(stateWithdraw * 0.98).toFixed(2) : "0.00"} {LocalConfig.currencyCode}
            </span>
          </p>
          {getPersist("abtest_tag") == "t8:g2" && (
            <p class={style.withdraw_bt}>
              <span>Gas consumption</span>
              <span class={style.withdraw_btr}>
                {stateWithdraw ? Math.ceil(stateWithdraw * NumericalConfig.gasBurnRatio).toFixed(0) : "0"}
              </span>
            </p>
          )}
          <p class={style.withdraw_fee}>
            Withdrawal service fee of <span class={style.withdraw_bc}>2%</span>, with any fractional amount ceiled to
            the next whole number.{" "}
          </p>
        </div>
        <div class={style.btncommontwo}>
          <div class={style.paybtnbox}>
            <button
              class={`${style.paybtn} ${style.paybtn1}${
                stateWithdraw < minWithdraw ? ` ${style.paybtn_disabled}` : ""
              }`}
              onClick={() => doWithdraw()}
            >
              Withdraw
            </button>
          </div>
        </div>
        <div class={style.deposit_phone}>
          <img src={LocationInfo().flag} alt="" />
          <span class={style.deposit_pc}>+{LocationInfo().phoneStartsWith}</span>
          <span>{getPersist("user_info") ? getPersist("user_info").rolename : null}</span>
        </div>
        <p class={style.depositedes}>
          You can only use your register number to withdraw, if not correct please register with your mobile money
          number again.
        </p>
        <div class={style.deposit_describe}>
          <h5>----------- Withdraw Tips -----------</h5>
          <p> 1. Please select your Operator. </p>
          <p>
            {" "}
            2. Minimum per transaction is {LocalConfig.currencyCode}{" "}
            {(NumericalConfig.minWithdrawAmount / 100).toFixed(2)}.{" "}
          </p>
          <p>
            {" "}
            3. Maximum per transaction is {LocalConfig.currencyCode}{" "}
            {(NumericalConfig.maxWithdrawAmount / 100).toFixed(2)}.{" "}
          </p>
          <p> 4. The money will be credited to your mobile money account instantly. </p>
          <p> 5. Withdrawal is available 24 hours*7. </p>
          <p> 6. Please contact our customer care if you have any issue with withdrawal. </p>
          {getPersist("abtest_tag") == "t8:g2" && (
            <>
              <p>
                7. Gas must be consumed for withdrawal transactions; each withdrawal of 1KES requires the consumption of
                10 gas units.
              </p>
              <p>
                8. Get gas by playing games (the more you bet the more gas you will get) or depositing.
              </p>
              {/* <p>
                8. Get gas by playing games (1KES bet for {NumericalConfig.betGasRatio} gas) or depositing (1KES deposit
                for {NumericalConfig.depositGasRatio} gas).
              </p> */}
            </>
          )}
        </div>
      </div>
      <Popup
        visible={showChooseChannel}
        style={{ height: "30%" }}
        position="bottom"
        className={style.withdrawChooseChannelDialog}
        onClose={() => {
          setShowChooseChannel(false);
        }}
      >
        <Picker
          columns={payments}
          placeholder={null}
          confirmButtonText={"Confirm"}
          cancelButtonText={"Cancel"}
          defaultValue={paymentIndex}
          onChange={(value) => {
            if (!payments[value]) {
              value = 0;
            }
            setPaymentIndex(value);
          }}
          onCancel={() => {
            setShowChooseChannel(false);
          }}
          onConfirm={() => {
            setShowChooseChannel(false);
          }}
        />
      </Popup>
      <Popup
        className={style.withdrawUnSuficientDialog}
        visible={suficientData && !suficientData.sufficient}
        // visible={1}
        title={"Betting Requirement"}
        closeable={false}
      >
        {suficientData ? (
          <div style={{ width: "85vw", backgroundColor: "#083d2b" }}>
            <div class={style.unsuficientCard}>
              <div class={style.unsuficientProp}>
                {`${suficientData.total_bet / 100} / ${suficientData.first_recharge_bet_need / 100}`}
              </div>
              <InviteProgress
                width="100%"
                height={"1.3rem"}
                borderRadius={"1.2rem"}
                percentage={(suficientData.total_bet / suficientData.first_recharge_bet_need) * 100}
                // textColor={"#e700fc"}
                // fontSize={"0.6rem"}
                // progressColor={"#ffd700"}
                // backgroundColor={"#093532"}
                text={`${suficientData.total_bet / 100} / ${suficientData.first_recharge_bet_need / 100}`}
              />
            </div>
            <div class={style.unsuficientTip}>
              Since you participated in the first deposit activity, you need to bet at least{" "}
              <span>{suficientData.first_recharge_bet_need / 100}</span> to withdraw
            </div>
            <div class={style.btncommontwo} style={{ padding: "1rem", width: "90%" }}>
              <div class={style.paybtnbox}>
                <button class={`${style.paybtn} ${style.paybtn1}`} onClick={() => history.goBack()}>
                  OK
                </button>
              </div>
            </div>
          </div>
        ) : null}
      </Popup>
    </div>
  );
};

export default Withdraw;
